// Text us widget (EV-161) v2.1 - posts to n8n zone-text-us, shows the Podium-style "received" card
(function () {
  var root = document.getElementById('zm-textus');
  if (!root) return;

  var endpoint = root.getAttribute('data-endpoint');
  var phone = root.getAttribute('data-phone') || '';
  var env = root.getAttribute('data-env') || 'preview'; // n8n routes non-live alerts to e@ only
  var bubble = root.querySelector('.zm-textus__bubble');
  var panel = root.querySelector('.zm-textus__panel');
  var closeBtn = root.querySelector('.zm-textus__close');
  var form = root.querySelector('.zm-textus__form');
  var done = root.querySelector('.zm-textus__done');
  var errorEl = root.querySelector('[data-error]');
  var failEl = root.querySelector('[data-fail]');
  var sendBtn = root.querySelector('.zm-textus__send');
  var prompt = root.querySelector('.zm-textus__prompt');
  var openedAt = 0;
  var PROMPT_KEY = 'zm-textus-prompt-closed';

  var MSG_LIMITED = "You've already sent us a few messages. We'll be in touch shortly.";
  var MSG_EMPTY = 'Please fill in your name, mobile and message.';
  var MSG_NETWORK = "Sorry, we couldn't send that. Please " +
    (phone ? 'call us on ' + phone + ' or ' : '') + 'email info@zonemedical.com.au.';

  function promptClosed() {
    try { return sessionStorage.getItem(PROMPT_KEY) === '1'; } catch (e) { return false; }
  }

  function hidePrompt(remember) {
    prompt.hidden = true;
    if (remember) {
      try { sessionStorage.setItem(PROMPT_KEY, '1'); } catch (e) { /* storage blocked: prompt returns next page */ }
    }
  }

  function openPanel() {
    hidePrompt(true);
    panel.hidden = false;
    root.classList.add('is-open');
    bubble.setAttribute('aria-expanded', 'true');
    if (!openedAt) openedAt = Date.now();
    var first = form.hidden ? closeBtn : form.querySelector('[name="name"]');
    if (first) first.focus();
  }

  function closePanel() {
    panel.hidden = true;
    root.classList.remove('is-open');
    bubble.setAttribute('aria-expanded', 'false');
    bubble.focus();
  }

  function show(el, text) {
    el.textContent = text;
    el.hidden = !text;
  }

  var fields = [form.elements.name, form.elements.mobile, form.elements.message];
  var sending = false;

  function syncSend() {
    var filled = fields.every(function (f) { return f.value.trim() !== ''; });
    sendBtn.disabled = sending || !filled;
  }

  function growMessage() {
    var box = form.elements.message;
    box.style.height = 'auto';
    box.style.height = Math.max(37, box.scrollHeight) + 'px';
  }

  fields.forEach(function (f) { f.addEventListener('input', syncSend); });
  form.elements.message.addEventListener('input', growMessage);

  function maskMobile(value) {
    var digits = String(value).replace(/\D/g, '');
    return '•••••••' + digits.slice(-4);
  }

  bubble.addEventListener('click', openPanel);
  prompt.querySelector('.zm-textus__prompt-open').addEventListener('click', openPanel);
  prompt.querySelector('.zm-textus__prompt-close').addEventListener('click', function () { hidePrompt(true); });
  if (!promptClosed()) {
    setTimeout(function () { if (panel.hidden) prompt.hidden = false; }, 3000);
  }
  closeBtn.addEventListener('click', closePanel);
  root.querySelector('.zm-textus__head-close').addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) closePanel();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    show(errorEl, '');
    show(failEl, '');

    var data = {
      name: form.elements.name.value.trim(),
      mobile: form.elements.mobile.value.trim(),
      message: form.elements.message.value.trim(),
      website: form.elements.website.value,
      opened_at: openedAt,
      page: window.location.href.split('#')[0].slice(0, 300),
      env: env
    };
    if (!data.name || !data.mobile || !data.message) {
      show(failEl, MSG_EMPTY);
      return;
    }

    sending = true;
    syncSend();
    sendBtn.classList.add('is-sending');
    sendBtn.textContent = 'Sending...';

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          return { status: res.status, body: body };
        });
      })
      .then(function (r) {
        if (r.status === 200) {
          root.querySelector('[data-masked]').textContent = maskMobile(data.mobile);
          root.querySelector('[data-echo]').textContent = data.message;
          form.hidden = true;
          done.hidden = false;
          closeBtn.focus();
        } else if (r.status === 400) {
          show(errorEl, (r.body && r.body.error) || 'Please check your details.');
        } else if (r.status === 429) {
          show(failEl, MSG_LIMITED);
        } else {
          show(failEl, MSG_NETWORK);
        }
      })
      .catch(function () {
        show(failEl, MSG_NETWORK);
      })
      .then(function () {
        sending = false;
        sendBtn.classList.remove('is-sending');
        sendBtn.textContent = 'Send';
        syncSend();
      });
  });
})();
